module.exports = __webpack_public_path__ + "img/exc_3.3e21b6e5.webp";